import { getMagazine, updateMagazine, updatePublication } from '../api/api';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { FileUpload } from 'primereact/fileupload';
import { Checkbox } from 'primereact/checkbox';
import { createPublication, getPublicationPresignedUrl, uploadPDF } from '../api/api';


function MagazineDetail() {

  const [magazine, setMagazine] = useState();
  const [isVisible, setIsVisible] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const [isEditingMagazine, setIsEditingMagazine] = useState(false)
  const [input, setInput] = useState({ name: '', description: '' })
  const [file, setFile] = useState(null)
  const [errors, setErrors] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [checked, setChecked] = useState(false);
  const [pdfUploaded, setPdfUploaded] = useState(false)
  // get router params
  const { magazineId } = useParams();

  useEffect(() => {
    loadMagazine()
  }, []);

  useEffect(() => {
    if (isEditing) {
      setPdfUploaded(isEditing.pdfUploaded)
      setInput({ name: isEditing.name, description: isEditing.description })
    }

    if (isEditingMagazine) {
      setInput({ name: isEditingMagazine.name, description: isEditingMagazine.description })
    }
  }, [isEditing, isEditingMagazine])

  const getFriendlyDate = (date) => {
    const dateObj = new Date(date);
    return dateObj.toLocaleDateString();
  }

  const handleInputChange = (e) => {
    setInput({
      ...input,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    if (validate()) {
      setIsLoading(true)
      const response = await createPublication(magazineId, input)
      if (file) {
        const url = await getPublicationPresignedUrl(magazineId, response.id)
        await uploadPDF(url.url, file)
      }
      setIsLoading(false)
      setIsVisible(false)
      loadMagazine()
    }
  }

  const handlePublicationUpdate = async () => {
    if (validate(!isEditing.pdfUploaded)) {
      setIsLoading(true)
      const response = await updatePublication(magazineId, isEditing.id, input)
      if (file) {

        const url = await getPublicationPresignedUrl(magazineId, response.id)
        await uploadPDF(url.url, file)
      }
      setIsLoading(false)
      setIsEditing(false)
      loadMagazine()
    }
  }

  const loadMagazine = async () => {
    getMagazine(magazineId).then((data) => {
      setMagazine(data);
    }).catch((error) => {
      console.log(error);
    });
  }

  const handleFileSelect = (e) => {
    setFile(e.files[0])
  }

  const validate = () => {
    let errors = {}
    if (!input.name) {
      errors.name = "Elija un nombre";
    }
    setErrors(errors)
    return Object.keys(errors).length === 0;
  }

  const handleMagazineUpdate = async (magazineId) => {
    if (validate(false)) {
      setIsLoading(true)
      await updateMagazine(magazineId, input)
      setIsLoading(false)
      setIsEditingMagazine(false)
    }
  }

  return (

    magazine && (
      <div className='p-4 pt-2'>
        <Dialog header='Editar revista' contentStyle={{ display: 'flex', flexDirection: 'column', width: '30vw' }} visible={isEditingMagazine} onHide={() => setIsEditingMagazine(false)}>
          <p>Nombre</p>
          <InputText name='name' value={input.name} onChange={handleInputChange} />
          {errors.name && <p className='errorText'>{errors.name}</p>}
          <p>Descripción</p>
          <InputTextarea name='description' value={input.description} onChange={handleInputChange} />
          <Button style={{ marginTop: '20px' }} label='Editar' onClick={() => handleMagazineUpdate(magazine.id)} loading={isLoading} />
        </Dialog>
        <Dialog header='Crear publicación' contentStyle={{ display: 'flex', flexDirection: 'column', width: '30vw' }} visible={isVisible} onHide={() => setIsVisible(false)}>
          <p>Nombre</p>
          <InputText name='name' value={input.name} onChange={handleInputChange} />
          {errors.name && <p className='errorText'>{errors.name}</p>}
          <p>Descripción</p>
          <InputTextarea name='description' value={input.description} onChange={handleInputChange} />
          <p>Elegir archivo</p>
          <div className='uploadBtnContainer'>
            <FileUpload className='formButton' mode="basic" onSelect={handleFileSelect} chooseLabel="Elegir" />
            {errors.file && <p className='errorText'>{errors.file}</p>}
          </div>
          <Button label='Crear' onClick={handleSubmit} loading={isLoading} />
        </Dialog>
        <div className='titleContainer'>
          <h1 className='text'>{magazine.name}</h1>
          <div className='buttonContainer'>
            <Button style={{ marginRight: '20px' }} label='Crear nueva publicación' onClick={() => setIsVisible(true)} />
            <Button label='Editar revista' onClick={() => setIsEditingMagazine(magazine)} />
          </div>
        </div>
        <p>{magazine.description}</p>
        <DataTable value={magazine.publications} sortField="creationDate" sortOrder={-1} tableStyle={{ minWidth: '50rem' }}>
          <Column field="name" header="Título"></Column>
          <Column field="description" header="Descripción"></Column>
          <Column field='creationDate' header="Fecha de publicación" body={
            (publication) => {
              return getFriendlyDate(publication.creationDate);
            }}></Column>
          <Column header="PDF Subido" body={
            (publication) => {
              return publication.pdfUploaded ? 'Si' : 'No';
            }}></Column>
          <Column header="Ver" body={
            (publication) => {
              return <a href={`/magazine/${magazine.id}/publication/${publication.id}`}>Ver</a>
            }}></Column>
          <Column field="actions" header="Editar" body={
            (publication) => {
              return <Button label='Editar' onClick={() => setIsEditing(publication)} />
            }}></Column>
        </DataTable>
        <Dialog header='Editar publicación' contentStyle={{ display: 'flex', flexDirection: 'column', width: '30vw' }} visible={isEditing} onHide={() => setIsEditing(false)}>
          <p>Nombre</p>
          <InputText name='name' value={input.name} onChange={handleInputChange} />
          {errors.name && <p className='errorText'>{errors.name}</p>}
          <p>Descripción</p>
          <InputTextarea name='description' value={input.description} onChange={handleInputChange} />
          {pdfUploaded ?
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <p>Actualizar archivo</p>
              <Checkbox style={{ marginLeft: '20px' }} onChange={e => setChecked(e.checked)} checked={checked}></Checkbox>
            </div>
            :
            <>
              <p>Elegir archivo</p>
              <div className='uploadBtnContainer'>
                <FileUpload className='formButton' mode="basic" onSelect={handleFileSelect} chooseLabel="Elegir" />
                {errors.file && <p className='errorText'>{errors.file}</p>}
              </div>
            </>
          }
          {checked &&
            <div className='uploadBtnContainer'>
              <FileUpload className='formButton' mode="basic" onSelect={handleFileSelect} chooseLabel="Elegir" />
              {errors.file && <p className='errorText'>{errors.file}</p>}
            </div>}
          <Button label='Editar' onClick={handlePublicationUpdate} loading={isLoading} />
        </Dialog>
      </div>
    )

  );
}

export default MagazineDetail;
